import { Employee } from "api-client/models/Employee";

export enum ACTIONS {
    GET_USER_PROFILE_REQUEST = "USER/GET_USER_PROFILE_REQUEST",
    GET_USER_PROFILE_SUCCESS = "USER/GET_USER_PROFILE_SUCCESS",
    GET_USER_PROFILE_FAILURE = "USER/GET_USER_PROFILE_FAILURE",

    GET_SUBORDINATES_REQUEST = "USER/GET_SUBORDINATES_REQUEST",
    GET_SUBORDINATES_SUCCESS = "USER/GET_SUBORDINATES_SUCCESS",
    GET_SUBORDINATES_FAILURE = "USER/GET_SUBORDINATES_FAILURE",
}

interface GetUserProfileRequest {
    type: ACTIONS.GET_USER_PROFILE_REQUEST;
}

interface GetUserProfileSuccess {
    type: ACTIONS.GET_USER_PROFILE_SUCCESS;
    payload: Employee;
}

interface GetUserProfileFailure {
    type: ACTIONS.GET_USER_PROFILE_FAILURE;
}

interface GetSubordinatesRequest {
    type: ACTIONS.GET_SUBORDINATES_REQUEST;
}

interface GetSubordinatesSuccess {
    type: ACTIONS.GET_SUBORDINATES_SUCCESS;
    payload: Employee[];
}

interface GetSubordinatesFailure {
    type: ACTIONS.GET_SUBORDINATES_FAILURE;
}

export type ActionType =
    | GetUserProfileRequest
    | GetUserProfileSuccess
    | GetUserProfileFailure
    | GetSubordinatesRequest
    | GetSubordinatesSuccess
    | GetSubordinatesFailure;
